import {
  AfterViewInit,
  Component,
  OnInit,
  ViewChild,
  NgZone,
  ElementRef,
  VERSION,
  Inject,
  Input,
  ChangeDetectorRef
} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { HttpClientModule } from "@angular/common/http";
import { DataTableDirective } from "angular-datatables";
import { DOCUMENT } from "@angular/common";
import { logbaseService } from "../../services/logbase.service";
import { dataService } from "../../services/data.service";
import { DatePipe } from "@angular/common";
import { NgxSpinnerService } from "ngx-spinner";
import { TranslateService } from "@ngx-translate/core";
import { map } from 'rxjs/operators';
import { dateFormatPipe } from "../../pipes/dateFormatPipe";
import { MatTableDataSource } from "@angular/material/table";
export interface MontlyData{
  supplierCode:any;
  supplierName:any;
  specification:any;
  location:any;
  fc1:any;
  fc2:any;
  fc3:any;



}

@Component({
  selector: "app-po-fcmonthly",
  templateUrl: "./po-fcmonthly.component.html",
  styleUrls: ["./po-fcmonthly.component.scss"]
})
export class PoFcmonthlyComponent implements OnInit {
  displayedColumns = ['supplierCode', 'supplierName', 'location', 'specification','fc1','fc2','fc3'];
  dataSource: MatTableDataSource<MontlyData[]>;
  resultData: any;
  secondMonthData: any;
  thirdMonthData: any;
  firstMonthData: any;
  monthDetails: any;
  QuantityChartData: any;
  WeightChartData: any;
  VolumeChartData: any;
  monthlyView: any;
  locCodeList: any[];
  suppCodeList: any[];
  dropdownSettings: any;
  suppCode: any;
  locCode: any;
  supPoint: any;
  suppCodeTbl: any;
  locCodeTbl: any;

  suppDD: any;
  locDD = [];

  stackChartOpt = {
    scaleShowVerticalLines: true,
    responsive: true,
    legend: { position: 'top' },
    scales: {
      xAxes: [
        {
          stacked: true,
          gridLines: {
            drawOnChartArea: false
          }
        }
      ],
      yAxes: [
        {
          stacked: true,
          gridLines: {
            drawOnChartArea: false
          }
        }
      ]
    }
  };

  chartOpt = {
    scaleShowVerticalLines: true,
    responsive: true
  };

  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true
  };

  public monthLabels: string[];

  public barChartType: string = "bar";
  public barChartLegend: boolean = true;

  public lineChartColors: Array<any> = [
    {
      // First
      backgroundColor: "#004355",
      borderColor: "rgba(148,159,177,1)",
      pointBackgroundColor: "rgba(148,159,177,1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(148,159,177,0.8)"
    },
    {
      // Second
      backgroundColor: "#00677E",
      borderColor: "rgba(77,83,96,1)",
      pointBackgroundColor: "rgba(77,83,96,1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(77,83,96,1)"
    },
    {
      // Third
      backgroundColor: "#007892",
      borderColor: "rgba(148,159,177,1)",
      pointBackgroundColor: "rgba(148,159,177,1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(148,159,177,0.8)"
    },
    {
      // Fourth
      backgroundColor: "#0787A5",
      borderColor: "rgba(148,159,177,1)",
      pointBackgroundColor: "rgba(148,159,177,1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(148,159,177,0.8)"
    },
    {
      // Fifth Top
      backgroundColor: "#A7C9D8",
      borderColor: "rgba(148,159,177,1)",
      pointBackgroundColor: "rgba(148,159,177,1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(148,159,177,0.8)"
    }
  ];

  // ng2-table code

  public rows: Array<any> = [];
  public columns:any
  public page: number = 1;
  public itemsPerPage: number = 10;
  public maxSize: number = 5;
  public numPages: number = 1;
  public length: number = 0;
  public totalItems: any;

  public config: any

  private data: Array<any> = [];
  dropdownSingle: any;
  graphLocStg: any;
  public graphDispBtn: any = true;

  public items: Array<string> = ['Amsterdam', 'Antwerp', 'Athens', 'Barcelona',
    'Berlin', 'Birmingham', 'Bradford', 'Bremen', 'Brussels', 'Bucharest',
    'Budapest', 'Cologne', 'Copenhagen', 'Dortmund', 'Dresden', 'Dublin',
    'Düsseldorf', 'Essen', 'Frankfurt', 'Genoa', 'Glasgow', 'Gothenburg',
    'Hamburg', 'Hannover', 'Helsinki', 'Kraków', 'Leeds', 'Leipzig', 'Lisbon',
    'London', 'Madrid', 'Manchester', 'Marseille', 'Milan', 'Munich', 'Málaga',
    'Naples', 'Palermo', 'Paris', 'Poznań', 'Prague', 'Riga', 'Rome',
    'Rotterdam', 'Seville', 'Sheffield', 'Sofia', 'Stockholm', 'Stuttgart',
    'The Hague', 'Turin', 'Valencia', 'Vienna', 'Vilnius', 'Warsaw', 'Wrocław',
    'Zagreb', 'Zaragoza', 'Łódź'];

  public value: any = {};
  public _disabledV: string = '0';
  public disabled: boolean = false;
  cars: { label: string; value: string; }[];
  graphSuppDD: any[];

  public get disabledV(): string {
    return this._disabledV;
  }

  public set disabledV(value: string) {
    this._disabledV = value;
    this.disabled = this._disabledV === '1';
  }

  public selected(value: any): void {
  }

  public removed(value: any): void {
  }

  public typed(value: any): void {
  }

  public refreshValue(value: any): void {
    this.value = value;
  }

  public dataModel: any;

  constructor(
    private logbaseService: logbaseService,
    private spinner: NgxSpinnerService,
    private httpClient: HttpClient,
    private ref: ChangeDetectorRef,
    private translate: TranslateService
  ) {
    this.columns = [
      { title: this.translate.instant('SUPPLIERCODE'), name: "supplierCode", sort: false },
      { title: this.translate.instant("Supplier Name"), name: "supplierName", sort: false },
      { title: this.translate.instant("Location"), name: "location", sort: false },
      { title: this.translate.instant("Spec"), name: "specification", sort: false },
      // { title: "Avg for last 3 months", name: "avg", sort: false },
      {
        title: "",
        name: "fc1", sort: false
      },
      {
        title: "",
        name: "fc2", sort: false
      },
      {
        title: "",
        name: "fc3", sort: false
      }
    ];
    this.cars = [
      { label: 'Audi', value: 'Audi' },
      { label: 'BMW', value: 'BMW' },
      { label: 'Fiat', value: 'Fiat' },
      { label: 'Ford', value: 'Ford' },
      { label: 'Honda', value: 'Honda' },
      { label: 'Jaguar', value: 'Jaguar' },
      { label: 'Mercedes', value: 'Mercedes' },
      { label: 'Renault', value: 'Renault' },
      { label: 'VW', value: 'VW' },
      { label: 'Volvo', value: 'Volvo' }
    ];
    this.config = {
      paging: true,
      sorting: { columns: this.columns },
      filtering: { filterString: "" },
      className: ["table-striped", "table-bordered", "poTable"]
    };
  }

  ngOnInit() {
    // Angular2 multi select settings and config
    this.dropdownSettings = {
      idField:"id",
      textField:"itemName",
      singleSelection: false,
      text: "Select",
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: "UnSelect All",
      classes: "custom-class",
      badgeShowLimit: 2,
      enableCheckAll: true,
      enableSearchFilter: true
    };

    this.dropdownSingle = {
      idField: 'id',
      textField: 'itemName',
      singleSelection: true,
      text: "Select",
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: "UnSelect All",
      // classes: "custom-class",
      itemsShowLimit: 2,
      enableCheckAll: false,
      enableSearchFilter: true
    };

    this.graphLocStg = {
      idField: 'id',
      textField: 'itemName',
      singleSelection: false,
      text: "Select",
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: "UnSelect All",
      // classes: "custom-class",
      itemsShowLimit: 2,
      enableCheckAll: true,
      enableSearchFilter: true,
      disabled: true
    };

    this.setFilterData();

    this.onChangeTable(this.config, true);
    this.toGetSupplierCode();

    this.VolumeChartData = [];
    this.WeightChartData = [];
    this.QuantityChartData = [];


    this.config = {
      displayKey: "description", //if objects array passed which key to be displayed defaults to description
      search: true, //true/false for the search functionlity defaults to false,
      height: 'auto', //height of the list so that if there are more no of items it can show a scroll defaults to auto. With auto height scroll will never appear
      placeholder: 'Select', // text to be displayed when no item is selected defaults to Select,
      customComparator: () => { }, // a custom function using which user wants to sort the items. default is undefined and Array.sort() will be used in that case,
      limitTo: 10, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
      moreText: 'more', // text to be displayed whenmore than one items are selected like Option 1 + 5 more
      noResultsFound: 'No results found!', // text to be displayed when no items are found while searching
      searchPlaceholder: 'Search', // label thats displayed in search input,
      searchOnKey: 'name' // key on which search should be performed this will be selective search. if undefined this will be extensive search on all keys
    }
  }

  public changePage(page: any, data: Array<any> = this.data): Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? start + page.itemsPerPage : data.length;
    return data.slice(start, end);
  }

  public changeSort(data: any, config: any): any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== "" && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous: any, current: any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === "desc" ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === "asc" ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter(data: any, config: any): any {
    let filteredData: Array<any> = data;
    this.columns.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config.filtering.columnName].match(
          this.config.filtering.filterString
        )
      );
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns.forEach((column: any) => {
        if (item[column.name]) {
          if (
            item[column.name].toString().match(config.filtering.filterString)
          ) {
            flag = true;
          }
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChangeTable(
    config: any,
    page: any = { page: this.page, itemsPerPage: this.itemsPerPage }
  ): any {
    this.spinner.show();
    var pageNo;
    var sortData;

    var locSelected = [];
    var suppSelected = [];

    var dateFormatPipeFilter = new dateFormatPipe();

    if (page.page == undefined) {
      pageNo = 0;
    } else {
      pageNo = page.page - 1;
    }

    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    // To set sorting value based on column sorted
    // this.config.sorting.columns.forEach(function (value, key) {
    //   if (value.sort) {
    //     sortData = {
    //       name: value.name,
    //       sort: value.sort
    //     };
    //   } else {
    //     sortData = {
    //       name: "",
    //       sort: ""
    //     };
    //   }
    // });

    if (this.locCodeTbl) {
      this.locCodeTbl.forEach(function (value, key) {
        locSelected.push(value.itemName);
      });
    }

    if (this.suppCodeTbl) {
      this.suppCodeTbl.forEach(function (value, key) {
        suppSelected.push(value.itemName);
      });
    }

    if (locSelected.length <= 0) {
      locSelected = [];
    }

    if (suppSelected.length <= 0) {
      suppSelected = [];
    }

    if (this.locCode) {
      this.locCode.forEach(function (value, key) {
        locSelected.push(value.itemName);
      });
    }

    if (this.supPoint) {
      this.supPoint.forEach(function (value, key) {
        suppSelected.push(value.itemName);
      });
    }

    if (locSelected.length <= 0) {
      locSelected = [];
    }

    if (suppSelected.length <= 0) {
      suppSelected = [];
    }

    var dataToSend = {
      pageNum: pageNo,
      searchValue: "",
      size: this.itemsPerPage,
      sortColumn: "",
      sortType: "",
      location: locSelected,
      suplierCode: suppSelected
    };

    this.logbaseService.getFcMonthlyData(dataToSend).subscribe(result => {
      this.monthlyView = result;
      var viewArr;
      var viewData = [];
      var graphVolData = [];
      var graphWgtData = [];
      var graphQtyData = [];
      var setVolData: any;
      var setQtyData: any;
      var setWgtData: any;
      var graphLoc = [];
      var actualAvgLast3MoQty;
      var actualAvgLast3MoWeight;
      var actualAvgLast3MoVolume;
      var suppCode = [];
      var locCode = [];
      var suppCodeDD = [];
      var locCodeDD = [];
      var month1title, month2title, month3title;

      this.monthlyView.response.content.forEach(function (value, key) {
        value.locDetails.forEach(function (val, key) {
          setVolData = [
            eval(val.actualAvgLast3MoVolume),
            val.forcastFirstMonthVolume,
            val.forcastSecondMonthVolume,
            val.forcastThirdMonthVolume
          ];

          setWgtData = [
            eval(val.actualAvgLast3MoWeight),
            val.forcastFirstMonthWeight,
            val.forcastSecondMonthWeight,
            val.forcastThirdMonthWeight
          ];

          setQtyData = [
            eval(val.actualAvgLast3MoQty),
            val.forcastFirstMonthQuantity,
            val.forcastSecondMonthQuantity,
            val.forcastThirdMonthQuantity
          ];

          graphVolData.push(setVolData);
          graphWgtData.push(setWgtData);
          graphQtyData.push(setQtyData);

          graphLoc.push(val.plantName);

          if (val.actualAvgLast3MoQty == null) {
            actualAvgLast3MoQty = 0;
          } else {
            actualAvgLast3MoQty = val.actualAvgLast3MoQty;
          }
          if (val.actualAvgLast3MoWeight == null) {
            actualAvgLast3MoWeight = 0;
          } else {
            actualAvgLast3MoWeight = val.actualAvgLast3MoWeight;
          }
          if (val.actualAvgLast3MoVolume == null) {
            actualAvgLast3MoVolume = 0;
          } else {
            actualAvgLast3MoVolume = val.actualAvgLast3MoVolume;
          }

          if (value.supplierNameEN === undefined || value.supplierNameEN === 'null') {
            value.supplierNameEN = '-';
          }
          viewArr = {
            supplierCode: value.supplierCode,
            supplierName: value.supplierNameEN,
            specification:
              '<td class="no-pad rmPad"><div class="fullRow">Quantity</div><div class="fullRow">Weight</div><div class="fullRow">Volume</div></td>',
            location: val.plantName,
            fc1Title: val.forcastFirstMonthName,
            fc2Title: val.forcastSecondMonthName,
            fc3Title: val.forcastThirdMonthName,
            // avg:
            //   '<td class="no-pad"><div class="fullRow">' +
            //   parseFloat(actualAvgLast3MoQty.toFixed(2)) +
            //   '</div><div class="fullRow">' +
            //   parseFloat(actualAvgLast3MoWeight.toFixed(2)) +
            //   '</div><div class="fullRow">' +
            //   parseFloat(actualAvgLast3MoVolume.toFixed(2)) +
            //   "</div></td>",
            fc1:
              '<td class="no-pad"><div class="fullRow">' +
              parseFloat(val.forcastFirstMonthQuantity.toFixed(2)) +
              '</div><div class="fullRow">' +
              parseFloat(val.forcastFirstMonthWeight.toFixed(2)) +
              '</div><div class="fullRow">' +
              parseFloat(val.forcastFirstMonthVolume.toFixed(2)) +
              "</div></td>",
            fc2:
              '<td class="no-pad"><div class="fullRow">' +
              parseFloat(val.forcastSecondMonthQuantity.toFixed(2)) +
              '</div><div class="fullRow">' +
              parseFloat(val.forcastSecondMonthWeight.toFixed(3)) +
              '</div><div class="fullRow">' +
              parseFloat(val.forcastSecondMonthVolume.toFixed(2)) +
              "</div></td>",
            fc3:
              '<td class="no-pad"><div class="fullRow">' +
              parseFloat(val.forcastThirdMonthQuantity.toFixed(2)) +
              '</div><div class="fullRow">' +
              parseFloat(val.forcastThirdMonthWeight.toFixed(2)) +
              '</div><div class="fullRow">' +
              parseFloat(val.forcastThirdMonthVolume.toFixed(2)) +
              "</div></td>"
          };
          viewData.push(viewArr);
        });

      });

      this.data = viewData;
      this.dataSource=new MatTableDataSource<MontlyData[]>(this.data)

      // this.VolumeChartData = [
      //   { data: graphVolData[0], label: graphLoc[0] },
      //   { data: graphVolData[1], label: graphLoc[1] },
      //   { data: graphVolData[2], label: graphLoc[2] },
      //   { data: graphVolData[3], label: graphLoc[3] }
      // ];

      // this.WeightChartData = [
      //   { data: graphWgtData[0], label: graphLoc[0] },
      //   { data: graphWgtData[1], label: graphLoc[1] },
      //   { data: graphWgtData[2], label: graphLoc[2] },
      //   { data: graphWgtData[3], label: graphLoc[3] }
      // ];

      // this.QuantityChartData = [
      //   { data: graphQtyData[0], label: graphLoc[0] },
      //   { data: graphQtyData[1], label: graphLoc[1] },
      //   { data: graphQtyData[2], label: graphLoc[2] },
      //   { data: graphQtyData[3], label: graphLoc[3] }
      // ];

      if (viewData.length > 0) {
        month1title = viewData[0].fc1Title;
        month2title = viewData[0].fc2Title;
        month3title = viewData[0].fc3Title;
      } else {
        month1title = "-";
        month2title = "-";
        month3title = "-";
      }
        this.columns = [
          { title: this.translate.instant('SUPPLIERCODE'), name: "supplierCode", sort: false },
          { title: this.translate.instant('Supplier Name'), name: "supplierName", sort: false },
          { title: this.translate.instant('Location'), name: "location", sort: false },
          { title: this.translate.instant("Spec"), name: "specification", sort: false },
          {
            title: month1title,
            name: "fc1", sort: false
          },
          {
            title: month2title,
            name: "fc2", sort: false
          },
          {
            title: month3title,
            name: "fc3", sort: false
          }
        ];
      
      this.monthLabels = [
        // "Avg 3 Months",
        month1title,
        month2title,
        month3title
      ];

      this.length = this.monthlyView.response.totalElements;

      let filteredData = this.changeFilter(this.data, this.config);
      let sortedData = this.changeSort(filteredData, this.config);
      this.rows =
        page && config.paging ? this.changePage(page, sortedData) : sortedData;
      //this.length = sortedData.length;

      this.rerenderTable(this.config, true);
      this.ref.detectChanges();
      this.spinner.hide();
    });
  }

  public rerenderTable(
    config: any,
    page: any = { page: this.page, itemsPerPage: this.itemsPerPage }
  ): any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows =
      page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

  setFilterData() {
    this.spinner.show();

    var locCode = [];
    var suppCode = [];
    var dataResult: any;
    var suppCodeDD = [];
    var locCodeDD = [];

    var dataToSend = {
      pageNum: 0,
      searchValue: this.config.filtering.filterString,
      size: this.itemsPerPage,
      sortColumn: "",
      sortType: "",
      location: [],
      suplierCode: []
    };


    let userDetJson = JSON.parse(localStorage.getItem('userDetails'));
    this.logbaseService.getFcMonthlyData(dataToSend).subscribe(result => {
      dataResult = result;
      // dataResult.response.forEach(function(value, key) {
      //   locCode.push({ id: key, itemName: value });
      // });
      dataResult.response.content.forEach(function (value, key) {
        suppCode.push(value.supplierCode);

        value.locDetails.forEach(function (val, key) {
          locCode.push(val.plantName);
        });
      });

      suppCode.filter((x, i, a) => a.indexOf(x) == i);

      suppCode.forEach(function (value, key) {
        suppCodeDD.push({ id: key, itemName: value });
      });

      // if (userDetJson.supplierCode.length > 0) {
      //   userDetJson.supplierCode.forEach(function(value, key) {
      //     suppCodeDD.push({ id: suppCodeDD.length + 1, itemName: value });
      //   });
      // }

      // this.suppDD = suppCodeDD;
      // locCode.filter((x, i, a) => a.indexOf(x) == i);

      // locCode.forEach(function(value, key) {
      //   locCodeDD.push({ id: key, itemName: value });
      // });
      // this.locDD = locCodeDD;
      this.spinner.hide();
    });
  }

  resetDD() {
    this.locCodeTbl = [];
    this.suppCodeTbl = [];
    this.locCode = [];
    this.supPoint = [];

    this.graphDispBtn = true;

    // Enable the location dropdown
    this.graphLocStg = {
      singleSelection: false,
      text: "Select",
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: "UnSelect All",
      classes: "custom-class",
      badgeShowLimit: 2,
      enableCheckAll: true,
      enableSearchFilter: true,
      disabled: true
    };
    this.VolumeChartData = [];
    this.WeightChartData = [];
    this.QuantityChartData = [];

    // this.onChangeTable(this.config, true);
  }

  toGetSupplierCode() {
    this.spinner.show();
    this.logbaseService.getAllSupplierCode({ "supplierCodes": [] }).subscribe(result => {
      let supplierCode;
      supplierCode = result;
      let suppCodeDD = [];
      let graphSuppDD = [];
      if (supplierCode.response.length > 0) {
        supplierCode.response.forEach(function (value, key) {
          suppCodeDD.push({ id: suppCodeDD.length + 1, itemName: value.supplierCode });
          graphSuppDD.push({ label: value.supplierCode, value: value.supplierCode });
        });
      }
      this.suppDD = suppCodeDD;
      this.graphSuppDD = graphSuppDD;
      this.spinner.hide();
    });
  }

  onSupplierCodeSelect(item: any) {
    this.locCodeTbl = []
    this.toGetLocationCode(this.toGetFormatedsendBody(this.suppCodeTbl));
  }
  OnSupplierCodeDeSelect(item: any) {
    this.locCodeTbl = []
    if (this.suppCodeTbl.length > 0) {
      this.toGetLocationCode(this.toGetFormatedsendBody(this.suppCodeTbl));
    } else {
      this.locDD = [];
      this.onChangeTable(this.config, true);
    }
  }

  onSupplierCodeSelectAll(items: any) {
    this.locCodeTbl = []
    this.toGetLocationCode(this.toGetFormatedsendBody(items));
  }

  onSupplierCodeDeSelectAll(items: any) {
    this.locCodeTbl = []
    this.locDD = [];
    this.onChangeTable(this.config, true);
  }

  toGetLocationCode(locationCode) {
    this.spinner.show();
    this.logbaseService.getAllSupplierMonthlyCode(locationCode).subscribe(result => {
      let LocationCode;
      LocationCode = result;
      let temp = []
      if (LocationCode.response.length > 0) {
        for (let index = 0; index < LocationCode.response.length; index++) {
          if (LocationCode.response.length > 0) {
            if (LocationCode.response[index].locDetails !== undefined &&
              LocationCode.response[index].locDetails.length > 0) {
              for (let j = 0; j < LocationCode.response[index].locDetails.length; j++) {
                temp.push(LocationCode.response[index].locDetails[j]);
              }
            }
          }
        }
      }
      let locCodeDD = [];
      if (temp.length > 0) {
        temp.forEach(function (value, key) {
          locCodeDD.push({ id: locCodeDD.length + 1, itemName: value });
        });
      } else {
        locCodeDD = [];
      }
      const resultArray = [];
      const map = new Map();
      for (const item of locCodeDD) {
        if (!map.has(item.itemName)) {
          map.set(item.itemName, true);    // set any value to Map
          resultArray.push({
            id: item.id,
            itemName: item.itemName
          });
        }
      }
      let uniqueArray = []
      if (resultArray.length > 0) {
        resultArray.forEach(function (value, key) {
          uniqueArray.push({ id: uniqueArray.length + 1, itemName: value.itemName.location });
        });

      }
      this.locDD = uniqueArray;
      this.spinner.hide();
    });
  }

  toGetFormatedsendBody(data) {
    let returnBody = { "supplierCodes": [] }
    if (data.length > 0) {
      for (let index = 0; index < data.length; index++) {
        returnBody.supplierCodes.push(data[index].itemName);
      }
    }
    return returnBody
  };

  onGraphSuppSel(item: any) {

    var responseData;

    // Disable the location dropdown
    this.graphLocStg = {
      singleSelection: false,
      text: "Select",
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: "UnSelect All",
      classes: "custom-class",
      badgeShowLimit: 2,
      enableCheckAll: true,
      enableSearchFilter: true,
      disabled: false
    };

    this.graphDispBtn = false;

    this.locCode = [];

    this.logbaseService.monthlyGraphView(item.value).subscribe(result => {

      responseData = result;
      var locCodeList: any = [];

      if (responseData.response.locDetails) {

        responseData.response.locDetails.forEach(function (value, key) {
          locCodeList.push({ id: key, itemName: value.plantName });
        });

        this.locDD = locCodeList;
      }
    });
  };

  onGraphSuppDeSel(item: any) {
    this.locCode = [];

    this.graphDispBtn = true;

    // Enable the location dropdown
    this.graphLocStg = {
      singleSelection: false,
      text: "Select",
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: "UnSelect All",
      classes: "custom-class",
      badgeShowLimit: 2,
      enableCheckAll: true,
      enableSearchFilter: true,
      disabled: true
    };
  };

  showGraphData() {
    this.spinner.show();

    this.VolumeChartData = [];
    this.WeightChartData = [];
    this.QuantityChartData = [];

    var suppID = this.supPoint;
    var responseData: any;
    var graphLoopData;
    var locName = [];

    this.logbaseService.monthlyGraphView(suppID).subscribe(result => {
      responseData = result;
      this.resultData = responseData.response
      this.monthDetails = responseData.response.locDetails
      this.firstMonthData = this.monthDetails[0].forcastFirstMonthName;
      this.secondMonthData = this.monthDetails[0].forcastSecondMonthName;
      this.thirdMonthData = this.monthDetails[0].forcastThirdMonthName;

      var volDataArr: any = [];
      var wgtDataArr: any = [];
      var qtyDataArr: any = [];
      var volChartData: any = [];
      var filterLoc;
      var filterLocData: any = [];
      var fullVolData: any = [];
      var fullWgtData: any = [];
      var fullQtyData: any = [];
      var wgtChartData: any = [];
      var qtyChartData: any = [];
      if (this.locCode != null) {
        this.locCode.forEach(function (value, key) {
          filterLoc = responseData.response.locDetails.filter(item => item.plantName == value.itemName);
          filterLocData.push(filterLoc[0]);
        });

        if (filterLocData.length > 0) {
          graphLoopData = filterLocData;
        } else {
          graphLoopData = responseData.response.locDetails;
        }
      }

      if (graphLoopData) {
        graphLoopData.forEach(function (value, key) {

          let gvoldata = [];
          let gwgtdata = [];
          let gqtydata = [];

          // gvoldata.push(value.actualAvgLast3MoVolume);
          gvoldata.push(value.forcastFirstMonthVolume);
          gvoldata.push(value.forcastSecondMonthVolume);
          gvoldata.push(value.forcastThirdMonthVolume);
          fullVolData.push(gvoldata);

          // gwgtdata.push(value.actualAvgLast3MoWeight);
          gwgtdata.push(value.forcastFirstMonthWeight);
          gwgtdata.push(value.forcastSecondMonthWeight);
          gwgtdata.push(value.forcastThirdMonthWeight);
          fullWgtData.push(gwgtdata);

          // gqtydata.push(value.actualAvgLast3MoQty);
          gqtydata.push(value.forcastFirstMonthQuantity);
          gqtydata.push(value.forcastSecondMonthQuantity);
          gqtydata.push(value.forcastThirdMonthQuantity);
          fullQtyData.push(gqtydata);

          locName.push(value.plantName);

          volChartData.push(fullVolData);
          wgtChartData.push(fullWgtData);
          qtyChartData.push(fullQtyData);
        });
      }

      volChartData.forEach(function (value, key) {
        volDataArr.push({ data: value[key], label: locName[key] })
      });

      wgtChartData.forEach(function (value, key) {
        wgtDataArr.push({ data: value[key], label: locName[key] })
      });

      qtyChartData.forEach(function (value, key) {
        qtyDataArr.push({ data: value[key], label: locName[key] })
      });

      this.VolumeChartData = volDataArr;
      this.WeightChartData = wgtDataArr;
      this.QuantityChartData = qtyDataArr;

      this.spinner.hide();
    });
  }

}
